module.exports = __webpack_public_path__ + "static/media/main idea.60834b51.mp3";